import script from "./FLOCSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./FLOCSearch.vue?vue&type=script&setup=true&lang=ts"

import "./FLOCSearch.vue?vue&type=style&index=0&id=a380e046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a380e046"]])

export default __exports__